import React from "react";
import Paragraph from "@src/stories/elements/Paragraph/Paragraph";
import useMobileBreakpoint from "@arctheme-hooks/useMobileBreakpoint";
import { Button } from "@src/stories/elements/Button/Button";
import Blush from "../Blush/Blush";

export const Foundations = ({ settings }) => {
    const isMobile = useMobileBreakpoint(settings.mobile_breakpoint);
    const { blocks } = settings.settings;
    const { title, subtitle, subtitle_style, subtitle_style_mobile, description, diagram_image, header_style, header_style_mobile, body_style, body_style_mobile } = settings.settings.section;
    
    const headerStyle = isMobile ? header_style_mobile : header_style;
    const bodyStyle = isMobile ? body_style_mobile : body_style;
    const subtitleStyle = isMobile ? subtitle_style_mobile : subtitle_style;

    return (
        <div className="flex justify-between overflow-hidden relative">
            <div
                className={`absolute top-0 left-0 w-[286px] h-[30px] lg:h-[60px] bg-gradient-to-r from-[#EDD5C9] to-transparent`}/>
            <div className="relative flex flex-col gap-[24px] mt-[64px] mb-[32px] max-lg:mx-3 lg:m-[150px] w-[400px]">
                {title && <h2 className={headerStyle}>{title}</h2>}
                <div>
                    {subtitle && <h3 className={subtitleStyle}>{subtitle}</h3>}
                    {description && <Paragraph type={bodyStyle} text={description}/>}
                </div>

                <Blush size={300} color="#EDD5C9"/>
                {blocks.length > 0 && (
                    <div className="buttons z-[1] flex space-x-4">
                        {blocks.map((button, index) => {
                            const buttonSettings = button.settings;
                            return (
                                <Button
                                    key={index}
                                    styleType={buttonSettings.button_style_type || "button"}
                                    style={buttonSettings.button_style || "primary"}
                                    label={buttonSettings.button_text}
                                    link={buttonSettings.button_url}
                                    icon={buttonSettings.button_icon || "right-arrow-alt"}
                                    reverse={true}
                                />
                            );
                        })}
                    </div>
                )}
            </div>
            {diagram_image && (
                <div className="diagram relative left-[50px] hidden lg:block">
                    <img src={diagram_image} alt="Diagram"/>
                </div>
            )}
        </div>
    );
};

export default Foundations;